<template>
    <el-dialog
        title="选择产品链接"
        :visible.sync="visible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose"
    >
        <div
            v-loading.fullscreen.lock="loading"
            element-loading-text="正在加载数据"
            element-loading-background="rgba(255, 255, 255, 0)"
        >
            <div class="mb20">
                <el-input
                    v-model="keyword"
                    placeholder="请输入产品的链接地址"
                    style="width: 352px; margin-right: 10px"
                    size="medium"
                />
                <el-button type="primary" size="medium" @click="addLink">添加</el-button>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeader">
                <div slot="empty"><span v-if="!loading && tableData.length === 0">暂无数据</span></div>
                <el-table-column label="图片" align="center" header-align="center" width="65">
                    <template #default="{ row }">
                        <el-image style="width: 45px; height: 45px" :src="row.Image" fit="contain" />
                    </template>
                </el-table-column>
                <el-table-column header-align="center" label="产品地址">
                    <template #default="{ row }">
                        <div>
                            <a :href="row.link" target="_blank">{{ row.Title }}</a>
                            <p style="color: #999">{{ row.link }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="操作" width="190">
                    <template #default="{ row }">
                        <el-button type="primary" size="small" @click="selectLink(row.link)">选择</el-button>
                        <el-link style="margin-left: 20px" type="info" @click="deleteLink(row.Id)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="text-align: center; padding: 10px 0"
                background
                :current-page="query.index"
                :page-size="query.size"
                layout="prev, pager, next, total, jumper"
                :total="query.total"
                @current-change="handleCurrentChange"
            />
        </div>
    </el-dialog>
</template>
<script>
import config from '@packages/common/config.js';
export default {
    name: 'HistoryRecordselect',
    data() {
        return {
            visible: false,
            loading: false,
            keyword: '',
            tableData: [],
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            },
            query: {
                index: 1,
                size: 6,
                total: 0,
            },
        };
    },
    methods: {
        show() {
            this.visible = true;
            this.getLinkList();
        },
        getLinkList() {
            this.loading = true;
            this.$ajax
                .post('app/ca/getproductjson', {
                    pageIndex: this.query.index,
                })
                .then((res) => {
                    this.loading = false;
                    if (!res.Success) {
                        this.$message.warning(res.Tips);
                        return;
                    }
                    const len = res.Data.length;
                    if (res.Data && len) {
                        for (let i = 0; i < len; i++) {
                            res.Data[i].link = `https://detail.1688.com/offer/${res.Data[i].OfferId}.html`;
                            let src = res.Data[i].Image;
                            if (src) {
                                src = config.alicdn + src.replace('.jpg', '.200x200.jpg');
                            } else {
                                src = `${config.ossUiDomainUrl}aliProject/images/no_image100x100.jpg`;
                            }
                            res.Data[i].Image = src;
                        }
                        this.tableData = res.Data;
                        this.query.total = res.TotalCount;
                    } else {
                        this.tableData = [];
                    }
                });
        },
        handleCurrentChange(index) {
            this.query.index = index;
            this.getLinkList();
        },
        // 产品链接转化产品Id
        linkToOfferId(link) {
            let offerId = null;
            if (link.replace(/[\r\n]/g, '') != ' ' && link != '') {
                if (link.indexOf('.html') == -1 || link.indexOf('/offer/') == -1) {
                    return offerId;
                }
                var start = link.indexOf('/offer/') + 7;
                var end = link.indexOf('.html');
                offerId = link.substring(start, end);
            }
            return offerId;
        },
        isOfferId(offerId) {
            const pattern = /[^0-9]/g;
            if (offerId == null || pattern.test(offerId)) {
                return false;
            }
            return true;
        },
        addLink() {
            if (this.keyword === '') {
                this.$message.warning('请先选择产品的链接地址');
                return;
            }
            const offerId = this.linkToOfferId(this.keyword);
            if (!this.isOfferId(offerId)) {
                this.$message.warning('请输入正确的产品链接地址！');
                return;
            }
            this.loading = true;
            this.$ajax.post('app/ca/saveproduct', { offerId }).then((res) => {
                this.loading = false;
                if (!res.Success) {
                    this.$message.warning(res.Message);
                    return;
                }
                this.$message.success('添加成功!');
                this.getLinkList();
            });
        },
        selectLink(link) {
            this.$emit('getLink', link);
            this.tableData = [];
            this.keyword = '';
            this.visible = false;
        },
        deleteLink(id) {
            this.$confirm('确定删除该产品记录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.loading = true;
                    this.$ajax.post('app/ca/delproduct', { id }).then((res) => {
                        this.loading = false;
                        if (!res.Success) {
                            this.$message.warning(res.Message);
                            return;
                        }
                        this.$message.success(res.Message);
                        if (this.query.index > 1 && this.tableData.length === 1) {
                            this.query.index -= 1;
                        }
                        this.getLinkList();
                    });
                })
                .catch(() => {});
        },
        handleClose(done) {
            this.tableData = [];
            this.keyword = '';
            done();
        },
    },
};
</script>
